import {Button, Choice, Tooltip} from 'platform/components';
import {Box, HStack, Icon, Space, Text} from 'platform/foundation';

import {useState} from 'react';

import {isNil, isNotNil} from 'ramda';

import {type SaleRegime} from '@dms/api/sales';
import i18n from '@dms/i18n';

interface Props {
  regime: SaleRegime;
  regimes: readonly {value: SaleRegime; label: string}[];
  isDisabled: boolean;
  onCopy: (source: SaleRegime) => void;
}

export function CheckoutProfileDocumentCopy(props: Props) {
  const [copyFrom, setCopyFrom] = useState<SaleRegime | null>(null);

  return (
    <>
      <Space vertical={4} />
      <Box paddingHorizontal={4}>
        <HStack justify="flex-end">
          <Box width={['100%', '100%', '20%', '20%']} paddingLeft={3}>
            <HStack align="flex-end" spacing={3}>
              <Box flex={1}>
                <HStack spacing={1} align="center">
                  <Text size="xSmall" color="secondary">
                    {i18n.t('general.labels.source')}
                  </Text>
                  <Tooltip label={i18n.t('entity.checkout.labels.copyDocumentSettingsDescription')}>
                    <Icon value="action/info" color="text.secondary" size={4} tabIndex={0} />
                  </Tooltip>
                </HStack>
                <Space vertical={1} />
                <Choice
                  aria-label={i18n.t('general.labels.source')}
                  value={copyFrom}
                  options={props.regimes.filter((item) => item.value !== props.regime)}
                  onChange={setCopyFrom}
                  isDisabled={props.isDisabled}
                />
              </Box>
              <Button
                title={i18n.t('general.labels.copyTo')}
                variant="secondary"
                isDisabled={isNil(copyFrom) || copyFrom === props.regime || props.isDisabled}
                onClick={() => {
                  if (isNotNil(copyFrom) && copyFrom !== props.regime) {
                    props.onCopy(copyFrom);
                  }
                }}
              />
            </HStack>
          </Box>
        </HStack>
      </Box>
    </>
  );
}
